var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRingingBell = function SvgRingingBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.335 14H6.67M1.53 3.88a2.67 2.67 0 0 1 1.355-2.347M14.47 3.88a2.67 2.67 0 0 0-1.354-2.347m-1.114 3.8a4 4 0 0 0-8 0c0 2.06-.52 3.47-1.1 4.404-.49.787-.735 1.18-.726 1.29.01.121.036.168.134.24.088.066.487.066 1.285.066h8.815c.797 0 1.196 0 1.284-.066.098-.072.124-.119.134-.24.009-.11-.236-.503-.726-1.29-.58-.933-1.1-2.344-1.1-4.404"
  })));
};
export default SvgRingingBell;